document.addEventListener('DOMContentLoaded', () => {
  const getAnchor = (anchorLink) => {
    const urlString = window.location.href.toLowerCase()
    const url = new URL(urlString)
    const param = url.searchParams.get(anchorLink)
    triggerAnchor(param)
  }
  let triggerAnchor = (param) => {
    if (param != null) {
      const el = document.querySelector(`[data-anchor="${param}"]`)

      if (!el) return

      let counter = 0

      setTimeout(() => {
        const internval = setInterval(() => {
          if (counter <= (el.offsetTop - 150)) {
            counter += 50
          } else {
            clearInterval(internval)
          }
          document.body.scrollTop = counter // For Safari
          document.documentElement.scrollTop = counter // For Chrome, Firefox, IE and Opera
        }, 5)
      }, 500)
    }
  }
  getAnchor('anchorlink')
})
